import { render, staticRenderFns } from "./ItineraryDescription.vue?vue&type=template&id=f765cda0&scoped=true&"
import script from "./ItineraryDescription.vue?vue&type=script&lang=js&"
export * from "./ItineraryDescription.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryDescription.vue?vue&type=style&index=0&id=f765cda0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f765cda0",
  null
  
)

export default component.exports